<div mat-dialog-title>
	<span translate>auction-offer.soldTo.changed.warning</span>
</div>
<div mat-dialog-content>
	<span translate>confirm.continue</span>
</div>


<div mat-dialog-actions>
	<button type="button" mat-raised-button class="dialog-button copo-dialog-button-margin" (click)="changeSoldTo(true)" tabindex="-1">
		<span translate>offer.type.yes</span>
	</button>
	<button type="button" mat-raised-button (click)="changeSoldTo(false)"
		class="dialog-button copo-dialog-button-margin copo-button" tabindex="-1" copoFocusMe>
		<span translate>offer.type.no</span>
	</button>
</div>